import api from '@api/Api';

export default {

    getRoles() {
        return api().get('/roles');
    },

}
